export default {
  verbiage: state => {
    return state.verbiage
  },
  getLocale: state => {
    return state.locale
  }
}